import {
  GET_SERVEY_LIST_SUCCESS,
  GET_SERVEY_LIST_FAIL,
  ADD_SERVEY_SUCCESS,
  ADD_SERVEY_FAIL,
} from "../actions/_actionType";
// "service/actions/_actionType";
export default function survey(
  state = {
    list: [],
    error: false,
    success: false,
    message: "",
  },
  action
) {
  switch (action.type) {
    case GET_SERVEY_LIST_SUCCESS:
      return {
        ...state,
        list: action.list,
        error: false,
      };
    case GET_SERVEY_LIST_FAIL:
      return {
        ...state,
        error: true,
      };
    case ADD_SERVEY_SUCCESS:
      return {
        ...state,
        // list: action.list,
        success: true,
        message: "",
      };
    case ADD_SERVEY_FAIL:
      return {
        ...state,
        // list: action.list,
        success: false,
        error: true,
        message: action.message,
      };
    default:
      return state;
  }
}
